import { ArrowPathIcon, PlusIcon } from "@heroicons/react/24/outline";
import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useState } from "react";
import { insertRow, restoreDataSource } from "../../../../context/DataTableReducer";
import useDataTableContext from "../../../../context/useDataTableContext";

const DataTableFooter = () => {
    const { state, dispatch } = useDataTableContext();
    const [open, setOpen] = useState<boolean>(false);
    const [ignoreChanges, setIgnoreChanges] = useState<boolean>(true);
    const [ignoreVisibility, setIgnoreVisibility] = useState<boolean>(true);
    const [ignoreFootnotes, setIgnoreFootnotes] = useState<boolean>(true);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const { dataSource } = state;

    const onSynchronise = () => {
        setOpen(true);
        setIgnoreChanges(true);
        setIgnoreFootnotes(true);
        setIgnoreVisibility(true);
    };

    const onCancel = () => setOpen(false);

    const onConfirmSync = () => {
        setOpen(false);
        dispatch(restoreDataSource(ignoreChanges, ignoreVisibility, ignoreFootnotes));
    };

    return (
        <tfoot>
            <tr>
                {dataSource ? (
                    <td colSpan={state.columns.length + 1}>
                        <Button
                            size="small"
                            fullWidth
                            onClick={() => onSynchronise()}
                            startIcon={<ArrowPathIcon className="h-5 w-5" />}
                            sx={{ borderRadius: 0 }}
                        >
                            <Typography variant="body2" sx={{ textTransform: "uppercase", fontWeight: 700 }}>
                                Refresh Data
                            </Typography>
                        </Button>

                        <Dialog open={open} onClose={onCancel} fullWidth maxWidth={"sm"} fullScreen={fullScreen}>
                            <DialogTitle>Update Information Table</DialogTitle>
                            <DialogContent dividers>
                                <DialogContentText>
                                    Are you sure you wish to update the contents of this table with the data in the
                                    local database?
                                </DialogContentText>

                                <Box sx={{ display: "flex" }}>
                                    <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                                        <FormLabel component="legend">Data retention</FormLabel>
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={ignoreChanges}
                                                        onChange={(e) => setIgnoreChanges(e.target.checked)}
                                                        name="changes"
                                                    />
                                                }
                                                label="Retain manually modified values"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={ignoreFootnotes}
                                                        onChange={(e) => setIgnoreFootnotes(e.target.checked)}
                                                        name="footnotes"
                                                    />
                                                }
                                                label="Retain footnotes"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={ignoreVisibility}
                                                        onChange={(e) => setIgnoreVisibility(e.target.checked)}
                                                        name="visibility"
                                                    />
                                                }
                                                label="Retain modified visibility"
                                            />
                                        </FormGroup>
                                    </FormControl>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={onCancel}>Cancel</Button>
                                <Button variant="contained" onClick={onConfirmSync}>
                                    Update
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </td>
                ) : (
                    <td colSpan={state.columns.length + 1}>
                        <Button
                            sx={{
                                border: 0,
                                clip: "rect(0 0 0 0)",
                                height: "1px",
                                margin: "-1px",
                                overflow: "hidden",
                                padding: 0,
                                position: "absolute",
                                width: "1px",
                            }}
                            onFocus={() => dispatch(insertRow())}
                        />
                        <Button
                            size="small"
                            fullWidth
                            onClick={() => dispatch(insertRow())}
                            startIcon={<PlusIcon className="h-5 w-5" />}
                            sx={{ borderRadius: 0 }}
                        >
                            <Typography variant="body2" sx={{ textTransform: "uppercase", fontWeight: 700 }}>
                                Insert new row
                            </Typography>
                        </Button>
                    </td>
                )}
            </tr>
        </tfoot>
    );
};

export default DataTableFooter;
